import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Paragraph from '../Paragraph/Paragraph';

const BulletItemStyles = styled.li`
  display: flex;

  > :first-child {
    margin: 0 0.5rem;
  }
`;

const BulletItem = ({ color, text, children, fontWeight = 500, variant }) => {
  if (text) {
    return (
      <BulletItemStyles>
        <Paragraph variant={variant} color={color}>
          &#8226;
        </Paragraph>
        <Paragraph variant={variant} color={color} fontWeight={fontWeight}>
          {text}
        </Paragraph>
      </BulletItemStyles>
    );
  }

  if (children) {
    return (
      <BulletItemStyles>
        <Paragraph variant={variant} fontWeight={fontWeight} color={color}>
          &#8226;
        </Paragraph>{' '}
        {children}
      </BulletItemStyles>
    );
  }

  return null;
};

BulletItem.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  fontWeight: PropTypes.number,
  variant: PropTypes.string,
};

export default BulletItem;
